import React from "react";
import { Col, Row } from "antd";
import _ from "lodash";

import formFieldComponents from "../components/form/utils/formFieldComponents";
import CustomFieldEngine from "../../../customField/customFieldEngine";
import SectionPart from "../components/SectionPart";
import * as validationRules from "./index";
import { evaluateFieldCondition } from "./formConditions";

export const getFieldName = (sectionName, field) => {
  if (field.subSectionName) {
    return [sectionName, field.subSectionName, field.name];
  }
  return [sectionName, field.name];
};

export const getValidationRules = (field) => {
  const { rules: ruleNames = [], rulesParams = {} } = field;
  if (!ruleNames.length) {
    return [];
  }
  const rulesArr = ruleNames.map((ruleName) => {
    const rule = validationRules[ruleName];
    if (!rule) {
      return null;
    }
    if (typeof rule === "function" && rulesParams[ruleName]) {
      return rule(rulesParams[ruleName] || {});
    }
    return rule;
  });

  return _.compact(_.flatten(rulesArr));
};

const renderReactFromJson = (form, json) => {
  return json.formSections.map((section) => (
    <SectionPart key={section.sectionName} sectionId={section.sectionName} headerTranslationKey={section.sectionHeader}>
      {renderReactRowsJson({ section, rows: section.rows, form })}
    </SectionPart>
  ));
};

export const renderReactRowsJson = ({ section, rows, form }) => {
  return rows.map((row, rowIndex) => (
    <Row key={`${section?.sectionName}_row_${rowIndex}`} gutter={[16, 16]}>
      {row.fields.map((field) => {
        const FieldComponent = formFieldComponents[field.type] || CustomFieldEngine;
        const span = field.colSize || 8;

        let isVisible = true;
        let isDisabled = field.fieldProps?.disabled || false;
        let isRequired = field.required || false;

        if (field.conditions) {
          const { visibility, disabled, required } = field.conditions;
          if (visibility) {
            isVisible = evaluateFieldCondition(visibility, form);
          }
          if (!isVisible) {
            return null;
          }
          if (required) {
            isRequired = evaluateFieldCondition(required, form);
          }
          if (disabled) {
            isDisabled = evaluateFieldCondition(disabled, form);
          }
        }

        return (
          <Col span={span} key={`${section.sectionName}_${field.name}_${field.label}`}>
            <FieldComponent
              type={field.type}
              name={getFieldName(section.sectionName, field)}
              label={field.label}
              required={isRequired}
              rules={getValidationRules(field)}
              placeholder={field.placeholder}
              fieldProps={{ ...field.fieldProps, ...(isDisabled && { disabled: true }) }}
              formItemProps={field.formItemProps}
              form={form}
              {...field.dedicatedFieldProps}
            />
          </Col>
        );
      })}
    </Row>
  ));
};

export default renderReactFromJson;
